<template>
  <v-row justify="center">
    <v-dialog
		  v-model="openModal"
			persistent
			max-width="600px"
		>
      <v-card>
        <v-card-title>
          <span class="text-h5">Input Data Pengirim</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Nama" ref="nama" autofocus @keydown.enter="focusRefs('badan_usaha')" required v-model="formData.nama"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Badan Usaha" ref="badan_usaha" @keydown.enter="focusRefs('alamat')" required v-model="formData.badan_usaha"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field label="Alamat" ref="alamat" @keydown.enter="focusRefs('email')" required v-model="formData.alamat"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Email" ref="email" @keydown.enter="focusRefs('telp')" required v-model="formData.email"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Telp" ref="telp" @keydown.enter="focusRefs('ket')" required v-model="formData.telp"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="kota" ref="kota" disabled @keydown.enter="focusRefs('ket')" required v-model="formData.kota"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Ket" ref="ket" @keydown.enter="createData" required v-model="formData.ket"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text :disabled="loading" tabindex="-1" @click="$emit('close-modal'); resetFormData();">
            Close
          </v-btn>
          <v-btn color="blue darken-1" :loading="loading" text @click="createData">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateModal',
  props: ['openModal', 'tempData', 'kota'],
  data() {
    return {
      formData: {
				nama: '',
        badan_usaha: '',
				alamat: '',
				telp: '',
				email: '',
        kota: '',
        ket: ''
      },
      loading: false
    }
  },
  watch: {
    tempData(val) {
      if (val) {
        this.formData.nama = val;
      }
    },
    kota(val) {
      if (val) {
        this.formData.kota = val.text;
      }
    }
  },
  methods: {
    async createData() {
			this.loading = true;
			
			await axios
				.post(`pengirim`, this.formData)
					.then(res => {
						this.loading = false;
						this.$emit('update-data', res.data);

            this.resetFormData();
					})
					.catch(err => {
            this.loading = false;
            
						alert(err.response.data.message);
					}); 
    },
    resetFormData() {
      this.formData = {
				nama: '',
        badan_usaha: '',
				alamat: '',
				telp: '',
				email: '',
        kota: '',
        ket: ''
      };
      
      this.kota = '';
    },
    focusRefs(id) {
      this.$refs[id].$refs.input.focus();
    }
  },
}
</script>